// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";

import type { $Agent, $Site, $Team, $SiteOffice } from "flow/types";

type $Props = {
  agent: $Agent,
  site: $Site,
  team: $Team,
  office: $SiteOffice,
  classes: Object,
};

const ContactInfo = ({ agent, classes, site, team, office }: $Props) => {
  if (site.userId && agent) {
    return (
      <div className={classes.root}>
        {agent.cellPhone ? (
          <div className={classes.text}>
            <a
              href={`tel:${agent.cellPhone}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Cell: {agent.cellPhoneFormatted}
            </a>
          </div>
        ) : null}
        {agent.directPhone ? (
          <div className={classes.text}>
            <a
              href={`tel:${agent.directPhone}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Direct: {agent.directPhoneFormatted}
            </a>
          </div>
        ) : null}
        {agent.fax ? (
          <div className={classes.text}>
            <a
              href={`tel:${agent.fax}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Fax: {agent.faxFormatted}
            </a>
          </div>
        ) : null}
        {office && office.officePhone ? (
          <div className={classes.text}>
            <a
              href={`tel:${office.officePhone}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Office: {office.officePhoneFormatted}
            </a>
          </div>
        ) : null}
        {agent.email ? (
          <div className={classes.text}>
            <a href="/contact">{agent.email}</a>
          </div>
        ) : null}
        {office && office.email ? (
          <div className={classes.text}>
            <a href="/contact">{office.email}</a>
          </div>
        ) : null}
      </div>
    );
  } else if (site.teamId && team) {
    const urlFriendlyAddress = encodeURIComponent(
      `${team.fullStreetAddress || ""} ${team.cityStateZip}`
    );
    return (
      <div className={classes.root}>
        {team.cellPhone ? (
          <div className={classes.text}>
            <a
              href={`tel: ${team.cellPhone}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Cell: {team.cellPhoneFormatted}
            </a>
          </div>
        ) : null}
        {team.directPhone ? (
          <div className={classes.text}>
            <a
              href={`tel: ${team.directPhone}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Direct: {team.directPhoneFormatted}
            </a>
          </div>
        ) : null}
        {team.email ? (
          <div className={classes.text}>
            <a href="/contact">{team.email}</a>
          </div>
        ) : null}
        {team.streetAddress1 ? (
          <div className={classes.text}>
            <a
              href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.text}
            >
              {team.streetAddress1}
            </a>
          </div>
        ) : null}
        {team.streetAddress2 ? (
          <div className={classes.text}>
            <a
              href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
              target="_blank"
              rel="noopener noreferrer"
              className={classes.text}
            >
              {team.streetAddress2}
            </a>
          </div>
        ) : null}
        {team.cityStateZip ? (
          <div className={classes.text}>
            <a
              href={`https://maps.google.com/?q=${urlFriendlyAddress}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {team.cityStateZip}
            </a>
          </div>
        ) : null}
      </div>
    );
  } else {
    return null;
  }
};

const styles = (theme) => ({
  root: {
    "& p": {
      margin: "0",
      maxWidth: "none",
    },
  },
  text: {
    color: theme.colors.white,
    fontSize: "14px",
    lineHeight: "18px",
  },
});

export default withGlobalContext(withStyles(styles)(ContactInfo));
